__turbopack_context__.v({
  "className": "inter_87d3dcb1-module__SQWfhG__className",
  "variable": "inter_87d3dcb1-module__SQWfhG__variable",
});
